// extracted by mini-css-extract-plugin
module.exports = {"root":"SiteHeader_root__JSO41","rootFilter":"SiteHeader_rootFilter__Fxd2A"};